// Payment-mode classification — mirrors the legacy edit_receipt.php
// conditional logic. The seeded payment_modes are: Cash, Cheque, Bank
// Transfer, Bread4Scrap, Card, Free Collect (see
// server/src/database/seeds/020_global_reference_data.sql). The legacy
// PHP keys off case-insensitive name matches: any name containing
// "cheque" → cheque field; any name containing "bank", "transfer", or
// "bacs" → bank-details section; everything else hides both.

export type PaymentKind = 'cheque' | 'bank' | 'other';

export function getPaymentKind(name: string | null | undefined): PaymentKind {
  const s = (name ?? '').toLowerCase();
  if (s.includes('cheque')) return 'cheque';
  if (s.includes('bank') || s.includes('transfer') || s.includes('bacs')) {
    return 'bank';
  }
  return 'other';
}
